import { render, staticRenderFns } from "./cellActions.vue?vue&type=template&id=131ad54c"
import script from "./cellActions.vue?vue&type=script&lang=js"
export * from "./cellActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports